import Vue from 'vue'

Vue.filter('urlFormat', (value: string) => {
  if (value === null) {
    return ''
  }
  return value.replace('&', '%26')
})
